export const emailRegexp =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

export const passwordRegexp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export const phoneRegexp = {
  US: /^\+?1?\s*\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/,
};

export const alphanumericRegexp = {
  allowSpecialChars: /^[a-zA-Z0-9\s!@#$%^&*()_+\-=[\]{}|;:'",./<>?\\]*$/,
  allowSpaces: /^[a-zA-Z0-9\s]*$/,
  noSpaces: /^[a-zA-Z0-9]*$/,
};
